<div class="ux-modal modal-container" id="wrapper">
    <div class="modal-header">
        <h6 class="modal-title" style="width:100%;">{{title}}</h6>
        <div *ngIf="submitFlag" class="cursor text-right submit-button" (click)="submitFiles()">
            <div class="text-center">
                <i class="pi pi-plus text-2xl text-color-secondary"></i> Add
            </div>
        </div>
        <div (click)="close()" class="cursor close">
            <img src="assets/images/list-close.png" alt="Close" />
        </div>
    </div>
    <div class="modal-body">
        <div *ngIf="loading" class="loading-small-screen-scroll row col-12 upload-content" align="center">
            <img src="assets/images/landing-page/loading-more.svg" alt="Loader" />
        </div>
        <div *ngIf="changeFlag" class="row col-12 upload-content">
            <div class="col-6 content-item-col content-item-col-1">
                <div class="content-row content-row-1">
                    <h6>Existing File</h6>
                    <div class="file-item">
                        <div class="file-col file-icon">
                            <div class="attachment-col bg-col cursor" [ngClass]="{'doc-bg' : (existingItems[dynamicGid].flagId > 2 && existingItems[dynamicGid].flagId < 6)}" [ngStyle]="{'background-image': 'url(' + existingItems[dynamicGid].thumbFilePath + ')'}">
                                <div *ngIf="existingItems[dynamicGid].flagId == 2" class="poster">
                                    <img src="{{videoThumb}}" alt="Play">
                                </div>
                                <div *ngIf="existingItems[dynamicGid].flagId == 3" class="poster">
                                    <img src="{{audioThumb}}" alt="Play">
                                </div>
                            </div>
                        </div>
                        <div class="file-col file-info">
                            <div class="inner-row file-name truncate" title="{{mediaItems[dynamicGid].name}}">{{mediaItems[dynamicGid].name}}</div>
                            <div class="inner-row file-date"><span class="info-label">Uploaded On: </span><span class="date">{{existingItems[dynamicGid].date}}</span></div>
                            <div *ngIf="existingItems[dynamicGid].wsFlag" class="inner-row file-view">
                                <app-attachment-view [dynamicGid]="dynamicGid" [access]="fileAccess" [action]="fileAction" [hideLabel]="hideLabel" [attachments]="currentMediaItem"></app-attachment-view>
                                <span class="file-id">ID# {{existingItems[dynamicGid].mediaId}}</span>
                            </div>
                            <div *ngIf="!existingItems[dynamicGid].wsFlag" class="inner-row restrict">
                                <div class="access-text">You don't have access</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-row content-row-2">
                    <h6>New File</h6>
                    <div class="file-item">
                        <div class="file-col file-icon">
                            <div class="attachment-col bg-col cursor" [ngClass]="{'doc-bg' : (mediaItems[dynamicGid].flagId > 2 && mediaItems[dynamicGid].flagId < 6)}" [ngStyle]="{'background-image': 'url(' + mediaItems[dynamicGid].thumbFilePath + ')'}">
                                <video *ngIf="mediaItems[dynamicGid].flagId == 2" class="fillWidth" [src]="mediaItems[dynamicGid].videoFilePath" width="90" height="90" controls preload="none">
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                        <div class="file-col file-info ufile-info">
                            <div class="inner-row file-name truncate" title="{{mediaItems[dynamicGid].name}}">{{mediaItems[dynamicGid].name}}</div>
                            <div class="inner-row file-date"><span class="info-label">Date: </span><span class="date">{{mediaItems[dynamicGid].date}}</span></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6 content-item-col content-item-col-2">
                <div class="content-actions">
                    <div class="action-item" [ngClass]="{'hide': !act.visible}" *ngFor="let act of checkActionItems[dynamicGid]; let i = index;">
                        <div *ngIf="act.visible" class="ci-row ci-row-1">
                            <div class="ci-title"><span class="checkbox cursor" [ngClass]="{'active': act.checked}" (click)="onChangeAction(i)"></span>{{act.item.actionName}}</div>
                            <div class="ci-desc">{{act.item.actionDesc}}</div>
                        </div>
                    </div>
                    <div class="action-item action-name">
                        <div class="box-label">Proposed File Name</div>
                        <div class="name-box truncate" title="{{mediaItems[dynamicGid].newFileName}}">{{mediaItems[dynamicGid].newFileName}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!initialLoad && changeFlag" class="card flex justify-content-center">
            <p-paginator (onPageChange)="onPageChange($event)" [first]="initPage" [rows]="rows" [totalRecords]="totalRecords"></p-paginator>
        </div>
    </div>
</div>